import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Observable } from 'rxjs';

const BASE_URL = 'notifications';

@Injectable({
  providedIn: 'root',
})
export class SmsService {
  constructor(private apiService: ApiService) {}

  // configUrl = this.appConfigService.getConfig().serverURL + '/api/qr-generator/send-sms';

  sendSMS(params): Observable<any> {
    console.log('params SMS: ' + JSON.stringify(params));
    // tslint:disable-next-line:max-line-length
    return this.apiService.post(`${BASE_URL}/send-new-prevision-sms`, { qr: params.qr, telefono: Number(params.telefono), NAME1: params.NAME1, ARKTX: params.ARKTX, TKNUM: params.TKNUM, VBELN: params.VBELN, date: params.date });
  }
}
